<template>
	<div>
		
		<div class="mt-3 text-center" v-if="!firstLoadDone">
			<az-loading msg="Carregando Lista de Relatórios..." />
		</div>
		
		<div v-else>

			<template v-if="!lista.length && !dashboards.length">
				<az-empty-state msg="Nenhum relatório disponível." />
			</template>

			<template v-else>

				<div class="row">
					<div class="col col-12 col-md-3" v-for="(dashboard, idx) in dashboards" :key="idx">
						<router-link class="card-link" :to="{ name: 'custom-dashboard', params: { id: dashboard.id } }">
							<div class="card carde border-0" :class="dashboard.color 
                                    ? 'bg-' + dashboard.color + ( ( dashboard.color == 'warning' || dashboard.color == 'light' ) ? ' text-dark' : ' text-white' ) 
                                    : 'bg-primary text-white'">
								<div class="card-body">
									<h5 class="mb-0">{{ dashboard.title }}</h5>
								</div>
							</div>
						</router-link>
					</div>
				</div>

				<az-input
					class="mt-2 mb-3"
					placeholder="Pesquisar em relatórios..."
					icon="fa fa-search"
					ref="pesquisa"
					v-model="search">

					<template v-slot:buttonposb>
						<div class="input-group-append">
							<span class="input-group-text" id="basic-addon2" title="Quantidade de relatórios">{{ filteredList.length }}</span>
							
							<button type="button" class="btn btn-outline-secondary" title="Visualizações" @click="toggle_views_options()">
								<i class="fa-solid fa-eye"></i>
							</button>
							
							<template  v-if="pode_criar">
								<router-link :to="{ path: '/relatorio/editor' }" class="btn btn-outline-secondary" type="button">
									<i class="fa fa-plus" aria-hidden="true"></i>
								</router-link>

                                <router-link :to="{ name: 'dashboards' }" class="btn btn-outline-secondary" type="button">
									<i class="fa-solid fa-gauge-high"></i>
								</router-link>
							</template>
						</div>
					</template>

				</az-input>

				<template v-if="filtro.views_options">

					<az-sub-title title="Acessos e Visualizações" />

					<div v-if="filtro.views_options" class="form-row mb-3">
						<div class="col col-12 col-md-6">
							<az-periodo 
								:sync="true" 
								@sync="load(false)"
								v-model="filtro" />
						</div>
						<div class="col col-12" :class="pode_criar ? 'col-md-2' : 'col-md-3'">
							<az-input 
								type="checkbox-group"
								label="Visualizados"
								v-model="filtro.visualizados" />
						</div>
						<div class="col col-12" :class="pode_criar ? 'col-md-2' : 'col-md-3'">
							<az-input 
								type="checkbox-group"
								label="Minhas Visualizações"
								v-model="filtro.minhas" 
								@input="load()" />
						</div>
						<div class="col col-12 col-md-2" v-if="pode_criar">
							<az-input
								:edicao="!filtro.minhas"
								icon="fa fa-user"
								type="autocomplete" 
								optionsMode="aql"
								optionsData="id_usuario"
								optionsDisplay="search"
								optionsName="usuarios-recepcao"
								service="usuarios.index"
								:optionsParm="{ perfil: 9 }"
								placeholder="Usuário..."
								v-model="filtro.id_usuario" />
						</div>
					</div>

				</template>

				<az-empty-state icon="fa fa-search" msg="Nenhum relatório encontrado." v-if="groupedList.length === 0" />

				<div v-for="(group, ig) in groupedList" :key="ig">
				
					<az-break-title :title="ig" />
					
					<ul class="list-group mb-3">
						<li class="list-group-item d-flex justify-content-between hover-bg" v-for="(item, index) in group" :key="index">
							<div>
								<a class="card-link" href='#' @click.prevent="go(item)">
									{{ item.title }}
								</a>
								<span class="badge badge-secondary ml-2">#{{ item.id }}</span>
								<div v-if="item.uso" class="small text-muted">
									<span v-if="item.uso.id_usuario == $store.state.user.id_usuario">
										Meu último acesso 
										{{ filtro.views_options ? 'no período selecionado' : '' }}
										em:
									</span>
									<span v-else>
										Acessado por {{ item.uso.usuario.st_login }} no período selecionado em:
									</span>
									<span class="ml-1">
										{{ $util.getFormatDate(item.uso.created_at) }},
										{{ $util.getHumanDuration(item.uso.created_at) }}.
									</span>
								</div>
							</div>
							<div>
								<template v-if="item.id_query_meta">
									<router-link class="card-link my-3" :to="{ path: '/relatorio/editor/' + item.id }" v-if="pode_criar">
										<i class="fa fa-cog" aria-hidden="true"></i>
									</router-link>      
									<span v-else>
										<i class="fa fa-cog text-muted mr-3" aria-hidden="true"></i>
									</span>
								</template>

								<a href="#" @click.prevent="descrever(item)" class="card-link" v-if="item.descr">
									<i class="fas fa-info-circle"></i>
								</a>

								<a href="#" class="card-link my-3" @click.prevent="acessos(item)">
									<i class="fas fa-user-lock"></i>
									<span class="badge badge-light">{{ item.acessos.length }}</span>
								</a>
							</div>
						</li>
					</ul>

				</div>

			</template>

			<!-- Modal -->
			<div class="modal fade" id="descrModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content" v-if="query">
						<div class="modal-header">
							<h5 class="modal-title">{{ query.title }}</h5>
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
						</div>
						<div class="modal-body">
							<span v-html="query.descr"></span>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
						</div>
					</div>
				</div>
			</div>

		</div>

		<edicao-acessos ref="acessos" @refresh="load()" />

	</div>
</template>

<script type="text/javascript">
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from '../util/AzBreakTitle.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import AzLoading from '../util/AzLoading.vue';
import AzInput from '../shared/forms/AzInput.vue';
import EdicaoAcessos from '../cadastros/shared/EdicaoAcessos.vue';
import AzPeriodo from '../shared/forms/AzPeriodo.vue';
import AzSubTitle from '../util/AzSubTitle.vue';
	
export default {
	data(){
		return {
			lista: [],
			dashboards: [],
			firstLoadDone: false,
			query: null, 
			search: "", 
			pode_criar: false, 
			filtro: { 
				periodo: 'm', 
				id_usuario: "", 
				minhas: true,
				visualizados: true, 
				views_options: false, 
			}
		}
	},
	components: { 
		AzBreakTitle, 
		AzEmptyState, 
		AzLoading,
		AzInput, 
		EdicaoAcessos,
		AzPeriodo,
		AzSubTitle, 
	},

	computed: { 
		filteredList: function () { 
			return this.lista.filter(item => !this.search || JSON.stringify(item).toLowerCase().indexOf(this.search.toLowerCase()) >= 0 )
				.filter(item => !this.filtro.views_options || !this.filtro.visualizados || item.uso)
		},

		groupedList: function () { 
			let filtered = this.filteredList;

			if ( !filtered.length ) 
				return [];

			return _.groupBy (filtered, function (item) { 
				return item.query_group.name;
			});
		},
		menuList: function () { 
			let self = this;
			return [{
					label: 'Relatórios',
					items: this.lista.map(function(i) { 
								return {label: i.title, 
										icon: 'pi pi-fw pi-plus', 
										command:()=>{ self.$router.push({ path: "/relatorio/" + i.id}) }};
							})
			}];
		}
	},
	methods: { 
		toggle_views_options() { 
			this.filtro.views_options = !this.filtro.views_options;
			this.load();
		},

		acessos(item) { 
			this.$refs.acessos.abrir('App\\Query', item.id, item.title);
		},
		descrever(item) { 
			this.query = item;
			$('#descrModal').modal('show');
		},
		go (item) { 
			this.$router.push({ path: "/relatorio/" + item.id});
		},
		load () { 
			this.$store.commit('loading', true);
			let query = { q: 
							[ 
								{ name: "relatorios.index", parms: this.filtro },
								{ name: "dashboards.lista" }  
							]
						};

            const base = this.axios.defaults.baseURL;
            const redir = ( base.substr(0,5) == 'https'
                ? 'https://api-relatorio.klingo.app/api'
                : ''
            );

			this.axios.post(redir + '/aql?a=relatorio.index', query)
				.then(res => { 
					this.lista = res.data['relatorios.index'].data;
					this.dashboards = res.data['dashboards.lista'].data;
				})
				.catch(error => { 
					console.log(error);
				})
				.finally (() => { 
					this.$store.commit('loading', false);
					if ( !this.firstLoadDone ) { 
						this.firstLoadDone = true;

						this.$nextTick(() => { 
							this.$refs['pesquisa'].$refs.input.focus ();
						});
					}
				});
		}
	},
	mounted () { 
		this.$store.commit('setBreadcrumb', 
			[
				{ name: "Relatórios", path: "/relatorios"}
			]);

		this.$util.loadItem(this, { 
			service: 'usuarios', 
			func: 'tem_permissao_acesso',
			parms: { 
				resource_id: 15, 
				block_vazio: true, 
			}
		})
		.then(res => { 
			this.pode_criar = res.pode ? true : false;
		});

		this.load ();
	}
}

</script>